
function Unauthorized() {
    return (
        <>
            <article style={{ padding: "100px" }}>
                <h1>Oops!</h1>
                <p>You are not authorized to this content.</p>

            </article>
        </>
    )
}
export default Unauthorized